import { Col, Row } from "react-bootstrap";
import AdminLayout from "./layout/AdminLayout";

import UcrtReportList from "../components/admin/report/UcrtReportList";
const UcrtReport = () => {
  return (
    <AdminLayout>
      <Row>
        {/* <h1 className="title mb-4">Dashboard</h1> */}
        <Col className="container mb-4">
          <UcrtReportList />
        </Col>
      </Row>
    </AdminLayout>
  );
};

export default UcrtReport;
